import { Component, OnInit, Input, ViewChild, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { ContentActionComponent } from 'src/app/shared/content-action/content-action.component';
import { Confirmation } from 'src/app/enums/confirmation.enum';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { ErrorText } from 'src/app/enums/error-text.enum';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTable } from '@angular/material/table';
import { FormControl, FormGroup } from '@angular/forms';
import { FilterFormModal } from 'src/app/models/form-group.model';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'fury-sub-cover-item-list',
  templateUrl: './sub-cover-item-list.component.html',
  styleUrls: ['./sub-cover-item-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class SubCoverItemListComponent implements OnInit {

  @ViewChild('dataTable') table!: MatTable<any[]>;
  dragDisabled = true;
  @Input()
  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  columns = [
    { name: 'Title', property: 'title', visible: true, isModelProperty: true },
    { name: 'Description', property: 'description', visible: true },
    { name: 'Average Cost For Repair', property: 'averageCostForRepair', visible: true },
    { name: 'Average Cost For Replacement', property: 'averageCostForReplacement', visible: true },
    { name: 'Common Issues', property: 'commonIssues', visible: true },
    {name: 'Status', property: 'isActive', visible: true},
    { name: 'Actions', property: 'actions', visible: true }
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  itemList: any;
  filterValue: any;
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  searchedKeyword!: string;
  searchBy: string = 'title';
  searchType: string = 'contains';
  isShowFilter: boolean = false;
  coverId !: string;
  itemDetails: any;

  filterForm = new FormGroup<FilterFormModal>({
    searchBy: new FormControl(this.searchBy),
    searchType: new FormControl(this.searchType),
  });

  constructor(
    private apiservice: ApiService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.filterValue = 'Sub Covered Items';
    this.activatedRoute.params.subscribe((res: any)=>{
      if(res.id){
        this.coverId = res.id;
        this.getSubCoverItemList();
        this.getItemDetails();
      }
    })
    this.activatedRoute.queryParams.subscribe((res: any) => {
      this.pageIndex = res.page ? res.page - 1 : 0;
      this.searchedKeyword = res.keywords ? res.keywords : '';
      this.pageSize = res.size ? (res.size === 'all' ? 9999 : res.size) : 30;
      this.searchBy = res.searchBy ? res.searchBy : 'title';
      this.searchType = res.searchType ? res.searchType : 'contains';
      this.filterForm.patchValue({
        searchBy: this.searchBy,
        searchType: this.searchType
      });
    });
  }
  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }
  ngOnInit(): void {
  }
  
  pageSizeChange(event: any) {    
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(`/plan-management/sub-covered-items/sub-coverd-item-list/${this.coverId}?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
    this.getSubCoverItemList();
  }

  getSubCoverItemList() {
    this.apiservice.get(`admin/plan/sub-covered-item/get-sub-covered-items/${this.coverId}?page=${this.pageIndex + 1}&size=${this.pageSize}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`).subscribe((res: any) => {
      if (res.body) {
        if (res.body.planCoverItems.data) {
          this.itemList = res.body.planCoverItems.data;
          this.totalCount = res.body.planCoverItems.total;
          this.dataSource = new MatTableDataSource(this.itemList);
          this.cdr.detectChanges();
        } else {
          this.itemList = undefined;
        }
      }
    });
  }

  deleteCoveredItem(type: string, value: any) {
    const dialogref = this.dialog.open(ContentActionComponent, { width: '500px', data: { type, value } });
    dialogref.afterClosed().subscribe((res: Confirmation) => {
      if (res === Confirmation.Yes) {
        this.apiservice.delete(`admin/plan/sub-covered-item/delete-sub-covered-item/${value.planSubCoverItemId}`).subscribe((del: any) => {
          if (del.body) {
            this.apiservice.alert(del.body.message, ErrorType.Success);
            this.getSubCoverItemList();
          }
        }, err => {
          if (err) {
            this.apiservice.alert(ErrorText.SomeThingWentWrong, ErrorType.Error);
          }
        });
      }
    });
  }

  onFilterChange(value: string) {
      this.pageIndex = 0;
      this.searchedKeyword = value.trim();
      this.router.navigateByUrl(`/plan-management/sub-covered-items/sub-coverd-item-list/${this.coverId}?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
      this.getSubCoverItemList();
  }

 
  showFilter(){
    this.isShowFilter = !this.isShowFilter; 
  }
  serchByValue: any[] = [
    {title: 'Title', value: 'title'},
    {title: 'Description', value: 'description'},
  ];
  searchTypeValue: any[] = [
    {title: 'Contains', value: 'contains'},
    {title: 'Starts With', value: 'startsWith'},
    {title: 'Not Contains', value: 'notContains'},
    {title: 'End With', value: 'endWith'},
    {title: 'Equals', value: 'equals'},
    {title: 'Not Equals', value: 'notEquals'},
  ]
  filterChange(){
    this.searchType = this.filterForm.value.searchType;
    this.searchBy = this.filterForm.value.searchBy;
    this.router.navigateByUrl(`/plan-management/sub-covered-items/sub-coverd-item-list/${this.coverId}?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
    this.isShowFilter = false;
    this.getSubCoverItemList();
  };
  navigateSubCoverItemList(subId: any){
    this.router.navigateByUrl(`/plan-management/sub-covered-items/sub-item-inside-sub-cover-item-list/${subId}`)
  };
  navigateAddSubCoverdItem(){
    this.router.navigateByUrl(`/plan-management/sub-covered-items/add-sub-coverd-item/${this.coverId}`)
  };
  navigateEditSubCoverItem(subId: any){
    this.router.navigateByUrl(`/plan-management/sub-covered-items/edit-sub-coverd-item/${this.coverId}/${subId}`);
  };
  changeStatus(event: MatSlideToggleChange, row: any) {
    let data :any;
    data = {isCovered: event.checked};
    this.apiservice.patch(`admin/plan/sub-covered-item/change-covered-status/${row.planSubCoverItemId}`, data).subscribe((res: any) => {
      if (res.body) {
        this.apiservice.alert(res.body.message, ErrorType.Success);
      } else {
        row.isActive = !row.isActive;
        this.apiservice.alert(res.body.message, ErrorType.Warning);
      }
    }, err => {
      if (err) {
        row.isActive = !row.isActive;
        Object.keys(err.errors).map((error) => {
          this.apiservice.alert(err.errors[error], ErrorType.Error);
        })
      }
    });
  };
  getItemDetails(){
    this.apiservice.get(`admin/plan/sub-covered-item/get-sub-covered-item/${this.coverId}`).subscribe((res: HttpResponse<any>)=>{
      if(res.body?.planCoverItem){
        this.itemDetails = res.body.planCoverItem;
      }
    })
  }
  ngOnDestroy() { }

}
